import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import './searchsection.css';
import popupImage from '../../../assets/images/im_First Time Search.png';
import CloseIcon from '../../../assets/images/Ic_close.png';
const experienceRanges = {
  '15-20 Yrs': [15, 20],
  '20-25 Yrs': [20, 25],
  '30+ Yrs': [30, Infinity]
};

const PopupFilters = ({ showPopup, setShowPopup }) => {
  const [showSecondPopup, setShowSecondPopup] = useState(false);
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedExperience, setSelectedExperience] = useState('');
  const navigate = useNavigate();

  const dummyData = [
    {
      experience: '30',
      position: 'Plant Manager',
      industry: 'Pharmacy',
      location: 'Bangalore',
      salary: '35L/annum',
    },
    {
      experience: '20',
      position: 'CEO',
      industry: 'Chemical',
      location: 'Bangalore',
      salary: '35L/annum',
    },
    {
      experience: '20',
      position: 'CEO',
      industry: 'Textile',
      location: 'Bangalore',
      salary: '35L/annum',
    },
    {
      experience: '20',
      position: 'Plant Manager',
      industry: 'Chemical',
      location: 'Mumbai',
      salary: '35L/annum',
    },
    {
      experience: '17',
      position: 'Plant Manager',
      industry: 'Pharmacy',
      location: 'Bangalore',
      salary: '25L/annum',
    },
    {
      experience: '20',
      position: 'Plant Manager',
      industry: 'Textile',
      location: 'Pune',
      salary: '40L/annum',
    },
    {
      experience: '18',
      position: 'Plant Manager',
      industry: 'Design',
      location: 'Bangalore',
      salary: '25L/annum',
    },
    {
      experience: '17',
      position: 'Plant Manager',
      industry: 'Pharmacy',
      location: 'Chennai',
      salary: '26L/annum',
    },
  ];

  const fetchResults = (city, experienceRange) => {
    const [minExperience, maxExperience] = experienceRanges[experienceRange] || [0, Infinity];
    return dummyData.filter(item => {
      const matchesCity = !city || city === 'All Location' || item.location === city;
      const matchesExperience =
        !experienceRange ||
        (parseInt(item.experience) >= minExperience && parseInt(item.experience) <= maxExperience);

      return matchesCity && matchesExperience;
    });
  };

  const handleFindResults = () => {
    setShowPopup(false);
    setShowSecondPopup(true);

    setTimeout(() => {
      const results = fetchResults(selectedCity, selectedExperience);
      navigate('/search-results', {
        state: {
          results,
          selectedCity,
          selectedExperience
        }
      });
      setShowSecondPopup(false);
    }, 2000);
  };


  if (!showPopup && !showSecondPopup) return null;

  return (
    <>
      {showPopup && !showSecondPopup && (
        <div className="modal-overlay">
          <div className="searchfilters-modal-content">
            <button className="close-button" onClick={() => setShowPopup(false)}>
              <img src={CloseIcon} alt="Close" />
            </button>
            <div className="row">
              <div className="col-12 text-center">
                <div className="popup-image-container">
                  <img src={popupImage} alt="Popup" className="popup-image" />
                </div>
                <h2>Find your next leader effortlessly.</h2>
                <p>Just fill in the details and leave the rest to us.</p>
              </div>
              <div className="col-12 col-md-6 my-2">
                <label>Have a specific location in mind?</label>
                <select
                  className="form-select"
                  value={selectedCity}
                  onChange={(e) => setSelectedCity(e.target.value)}
                >
                  <option>Select City</option>
                  <option value="All Location">All Location</option>
                  <option value="Bangalore">Bangalore</option>
                  <option value="Chennai">Chennai</option>
                  <option value="Mumbai">Mumbai</option>
                  <option value="Pune">Pune</option>
                  <option value="Kolkata">Kolkata</option>
                </select>
              </div>
              <div className="col-12 col-md-6 my-2">
                <label className="work-experience-label">Work Experience?</label>
                <div className="btn-group w-100">
                  <button type="button" className="year-button" onClick={() => setSelectedExperience('15-20 Yrs')}>
                    15-20 Yrs
                  </button>
                  <button type="button" className="year-button" onClick={() => setSelectedExperience('20-25 Yrs')}>
                    20-25 Yrs
                  </button>
                  <button type="button" className="year-button" onClick={() => setSelectedExperience('30+ Yrs')}>
                    30+ Yrs
                  </button>
                </div>
              </div>
              <div className="col-12 text-center my-3">
                <button type="submit" className="find-button" onClick={handleFindResults}>Find Results</button>
              </div>
            </div>
          </div>
        </div>

      )}
      {showSecondPopup && (
        <div className="second-modal-overlay">
          <div className="second-modal-content">
            <ClipLoader size={50} color={'#F35824'} width={'80px'} height={'80px'} loading={true} />
            <h2>Loading the best candidates tailor-made for you. </h2>
            <p>This will take a moment...</p>
          </div>
        </div>
      )}
    </>

  );
};

export default PopupFilters;
